@if (!betCardRedesigned) {
    <div #settingsbuttonwrapperwrapper class="settings-button-wrapper-wrapper">
        <div class="settings-button-wrapper">
            <button
                ds-button
                kind="secondary"
                variant="outline"
                size="large"
                [popper]="cashoutSettingsContent"
                [popperTrigger]="NgxPopperjsTriggers.click"
                [popperHideOnClickOutside]="true"
                [popperAppendTo]="'ms-my-bets-earlypayout-container'"
                [popperBoundaries]="'ms-my-bets-earlypayout-container'"
                [popperPlacement]="NgxPopperjsPlacements.BOTTOMEND"
                [popperApplyClass]="'popper'"
                [popperFlip]="false"
                [popperApplyArrowClass]="'popper-arrow'"
                (click)="toggleCashoutSettings($event)"
                (popperOnHidden)="closeCashoutSettings($event)"
                (popperOnShown)="onShown($event)">
                @if (isEpcotEnabled) {
                    @if (settingsToggled) {
                        <vn-icon class="icon" name="theme-settings-i" size="16"></vn-icon>
                    } @else {
                        <vn-icon class="icon" name="theme-settings" size="16"></vn-icon>
                    }
                } @else {
                    {{ sitecore.earlyPayoutV2.Auto }}
                }
            </button>
            @if (showCircle) {
                <span class="circle"></span>
            }
        </div>
    </div>
} @else {
    <div class="earlypayout-wrapper">
        @if (!isCashoutSet) {
            <button
                ds-button
                msThemedButton
                kind="utility"
                variant="flat"
                size="medium"
                [popper]="cashoutSettingsContent"
                [popperTrigger]="NgxPopperjsTriggers.click"
                [popperHideOnClickOutside]="true"
                [popperAppendTo]="'ms-my-bets-earlypayout-container'"
                [popperBoundaries]="'ms-my-bets-earlypayout-container'"
                [popperPlacement]="NgxPopperjsPlacements.BOTTOMEND"
                [popperApplyClass]="'popper'"
                [popperFlip]="false"
                [popperApplyArrowClass]="'popper-arrow'"
                (click)="toggleCashoutSettings($event)"
                (popperOnHidden)="closeCashoutSettings($event)"
                (popperOnShown)="onShown($event)">
                {{ sitecore.earlyPayoutV2.SetAutoCashoutTitle }}
            </button>
        } @else {
            <div class="ep-auto-msg pt-sm-2">
                <span class="d-flex icon-text-container">
                    <vn-icon class="icon" name="theme-success-i" size="16" />
                    <span class="title"
                        >{{ sitecore.earlyPayoutV2.RemoveAutoCashoutLinkText }}
                        <span>{{ autoCashOutValue() | msCurrency: true }}</span>
                    </span>
                </span>

                <ds-divider vertical />
                <button
                    ds-button
                    msThemedButton
                    kind="utility"
                    variant="flat"
                    size="small"
                    class="remove-btn"
                    [popper]="cashoutSettingsContent"
                    [popperTrigger]="NgxPopperjsTriggers.click"
                    [popperHideOnClickOutside]="true"
                    [popperAppendTo]="'ms-my-bets-earlypayout-container'"
                    [popperBoundaries]="'ms-my-bets-earlypayout-container'"
                    [popperPlacement]="NgxPopperjsPlacements.BOTTOMEND"
                    [popperApplyClass]="'popper'"
                    [popperFlip]="false"
                    [popperApplyArrowClass]="'popper-arrow'"
                    (click)="toggleCashoutSettings($event)"
                    (popperOnHidden)="closeCashoutSettings($event)"
                    (popperOnShown)="onShown($event)">
                    {{ sitecore.earlyPayoutV2.RemoveAutoCashoutTitle }}
                </button>
            </div>
        }
    </div>
}
<popper-content #cashoutSettingsContent>
    <div class="cashout-settings-popup-content">
        <span (click)="cashoutSettingsContent.hide()"></span>
        <ms-my-bets-earlypayout-popper-tabs
            [betNumbers]="betslipNumbers"
            [closePopup]="cashoutSettingsContent"
            [betTypeInfo]="betTypeInfo"></ms-my-bets-earlypayout-popper-tabs>
    </div>
</popper-content>
